/**
 * @aim get code from url
 * @author clearlove
 * @data 19-09
 */
 export default {
    getUrlKey:function(name){
      return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
    }
}


// WEBPACK FOOTER //
// ./src/components/getUrl_utils.js